import http from '../../../http-common.js';

export default {
  async getClients(context, params = {}) {
    try {
      const qs = new URLSearchParams();
      if (params.first) qs.set('first', params.first);
      if (params.page) qs.set('page', params.page);
      if (params.status) qs.set('status', params.status);
      if (params.search) qs.set('search', params.search);
      if (params.vendor) qs.set('vendor', params.vendor);
      const url = qs.toString() ? `/clients?${qs.toString()}` : '/clients';

      const response = await http.get(url);
      if (response.status == 200) {
        const count = response.data.count;
        const responseData = response.data.clients;
        const pagination = response.data.pagination || {
          total: count, currentPage: 1, lastPage: 1,
          firstItem: count > 0 ? 1 : 0, lastItem: count, hasMorePages: false, perPage: count,
        };
        context.commit('setClients', responseData);
        context.commit('setClientsCount', count);
        context.commit('setClientsPagination', pagination);
      } else {
        const error = new Error('Something went wrong!');
        throw error;
      }
    } catch (error) {
      const errorMessage = {
        status: error.response && error.response.data && error.response.data.success,
        message: new Error((error.response && error.response.data && error.response.data.message) || 'Something failed!'),
      };
      throw errorMessage;
    }
  },
  async createClient(context, data) {
    let clientData;
    try {
      const response = await http.put('/clients', data);
      if (response.status == 201) {
        clientData = {
          clientName: data.clientName,
          username: data.username,
          email: data.email,
          secret: data.secret,
          xKey: data.xKey,
          callbackURL: data.callbackURL,
          payOutCallbackURL: data.payOutCallbackURL,
          failedOrderCallbackURL: data.failedOrderCallbackURL,
          is_instant_payout: data.is_instant_payout,
          wallet_callback: data.wallet_callback,
          instant_payout_limit: data.instant_payout_limit,
          vendor: data.vendor,
          payInCommission: data.payInCommission,
          payOutCommission: data.payOutCommission,
        };
      } else {
        const error = new Error('Something went wrong!');
        throw error;
      }
    } catch (error) {
      // Null-safe: a network/transport error has no `error.response`, so
      // reading `error.response.data.message` directly would throw its own
      // TypeError and bury the real cause. Fall back through response message
      // → axios message → generic.
      const msg =
        (error && error.response && error.response.data && error.response.data.message) ||
        (error && error.message) ||
        'Something failed!';
      throw new Error(msg);
    }

    context.commit('addClient', clientData);
  },
  async updateClient(context, data) {
    const clientName = data.clientName;
    delete data.clientName;
    let clientData;
    try {
      const response = await http.post(`/clients/${clientName}`, data);
      if (response.status == 200) {
        clientData = {
          clientName: clientName,
          email: data.email,
          secret: data.secret,
          xKey: data.xKey,
          callbackURL: data.callbackURL,
          payOutCallbackURL: data.payOutCallbackURL,
          failedOrderCallbackURL: data.failedOrderCallbackURL,
          is_instant_payout: data.is_instant_payout,
          wallet_callback: data.wallet_callback,
          instant_payout_limit: data.instant_payout_limit,
          payInCommission: data.payInCommission,
          payOutCommission: data.payOutCommission,
        };
      } else {
        const error = new Error('Something went wrong!');
        throw error;
      }
    } catch (error) {
      // Null-safe: a network/transport error has no `error.response`, so
      // reading `error.response.data.message` directly would throw its own
      // TypeError and bury the real cause. Fall back through response message
      // → axios message → generic.
      const msg =
        (error && error.response && error.response.data && error.response.data.message) ||
        (error && error.message) ||
        'Something failed!';
      throw new Error(msg);
    }

    context.commit('updateClient', clientData);
  },
  async changeClientStatus(context, data) {
    // `username` here is the joined users.username for the client (the row
    // in `users` table with role='client' that matches secrets.clientName).
    const username = data.username;
    const status = data.status;
    try {
      const response = await http.post(`/users/${username}/status`, { status });
      if (response.status == 200) {
        context.commit('changeClientStatus', { identifier: username, status });
      } else {
        throw new Error('Something went wrong!');
      }
    } catch (error) {
      const errorMessage = new Error(
        (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'Something failed!'
      );
      throw errorMessage;
    }
  }
};
